<div class="container">
  <div class="row min-vh-100 align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="card shadow-lg border-0 success-card">
        <div class="card-body text-center p-5">
          <!-- Icon de succès -->
          <div class="success-icon-wrapper mb-4">
            <div class="success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
          </div>

          <!-- Titre et message -->
          <h1 class="display-5 fw-bold text-success mb-3">Compte activé !</h1>
          <p class="lead text-muted mb-4">
            Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter et profiter de tous nos services.
          </p>

          <!-- Boutons d'action -->
          <div class="d-grid gap-2 d-md-flex justify-content-md-center">
            <button class="btn btn-success btn-lg px-4" routerLink="/signin">
              Se connecter
            </button>
            <button class="btn btn-outline-secondary btn-lg px-4" routerLink="/">
              Retour à l'accueil
            </button>
          </div>

          <!-- Message additionnel -->
          <div class="mt-4 pt-4 border-top">
            <p class="text-muted small mb-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-1">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              Un email de confirmation vous a été envoyé
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
